export const GENERAL_CONSTS = {
    SET_ROUTES:"SET_ROUTES"
}